function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "155",
  height: "19",
  viewBox: "0 0 155 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#6B1BE3",
  d: "M.34 6h2v7h-2zM40.34 6h2v7h-2zM56.34 6h2v7h-2zM60.34 6h2v7h-2zM76.34 6h2v7h-2zM96.34 6h2v7h-2zM108.34 6h2v7h-2zM112.34 6h2v7h-2zM120.34 6h2v7h-2zM128.34 6h2v7h-2zM140.34 6h2v7h-2zM144.34 6h2v7h-2zM152.34 6h2v7h-2zM52.34 6h2v7h-2zM4.34 3h2v13h-2zM24.34 3h2v13h-2zM32.34 3h2v13h-2zM44.34 3h2v13h-2zM88.34 3h2v13h-2zM100.34 3h2v13h-2zM132.34 3h2v13h-2zM8.34 4h2v11h-2zM20.34 4h2v11h-2zM48.34 4h2v11h-2zM84.34 4h2v11h-2zM104.34 4h2v11h-2zM92.34 4h2v11h-2zM136.34 4h2v11h-2zM64.34 4h2v11h-2zM80.34 4h2v11h-2zM68.34 5h2v9h-2zM116.34 5h2v9h-2zM124.34 5h2v9h-2zM148.34 5h2v9h-2zM72.34 5h2v9h-2zM12.34 0h2v19h-2zM36.34 0h2v19h-2zM16.34 1h2v16h-2zM28.34 1h2v16h-2z"
})));